<template>
  <div id="jumbo" class="container-fluid" data-v-caa1c4b2></div>
  <div id="art" class="container">
    <h1>Calm Series</h1>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/White_1_q.54abad7a.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal21"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">White 1 (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/White_2_q.3e099094.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal22"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">White 2 (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/White_Splash_q.02a3fb9f.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal23"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">White Splash (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/White_Greige_q.097ba721.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal24"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">White Greige (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Quiet_ocean_quadrat.f34fb6f0.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal1"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Quiet Ocean (2023)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Spring_quadrat.00b9b966.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal3"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Spring (2023)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Ocean_quadrat.f8fa7592.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal2"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Ocean (2023)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Blue_Ocean_quadrat.d59fa102.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal4"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Blue Ocean (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Green_White_quadrat.7c89bacf.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal5"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Green White (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Calm_quadrat.926507a5.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal6"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Calm (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Neon_quadrat.abd9c67d.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal7"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Neon_2q.96a334ca.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal8"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon 2 (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Neon_3_neu_q.dbd43878.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal9"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon 3 (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Neon_4q.56fedcb4.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal10"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon 4 (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_Neon_5q.0f7873f2.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal11"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon 5 (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_calm.9318828d.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal12"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Calm 2 (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink-girl_q.a1dbf804.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal20"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Girl (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Pink_neon_dreamland.57170f47.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal14"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Pink Neon Dreamland (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Beige_quadrat.9d9e0fa3.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal15"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Calm Beige (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Beige_wonderland.df9dd75b.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal16"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Beige Wonderland (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Greige_1_quadrat.d439640a.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal17"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Greige (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Greige_dark.944971b1.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal18"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Greige Dark (2024)</p>
      </div>
    </div>
    <div class="row justify-content-center" style="margin-top: 30px">
      <div class="col-12 col-md-4">
        <img
          src="/img/Greige_light.6d4bd97a.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal19"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Greige Light (2024)</p>
      </div>
      <div class="col-12 col-md-4">
        <img
          src="/img/Ocean_2_quadrat.e1c722a2.jpg"
          class="img-fluid"
          alt="..."
          data-bs-toggle="modal"
          data-bs-target="#exampleModal13"
          style="width: 80%; cursor: pointer"
        />
        <p style="margin-top: 10px">Ocean 2 (2024)</p>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal1"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls1"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Quiet_ocean.bfdb8765.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Quiet_ocean_V.c0a758ae.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls1"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls1"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Quiet Ocean, Acryl on Canvas, 120 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal2"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/img/Ocean.e1d90e4f.jpg" class="img-fluid" alt="..." style="max-height: 70vh" />
        </div>
        <div class="modal-footer">Ocean, Acryl on Canvas, 120 x 100 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal3"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Spring.87b600d1.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Spring_room.23ff3aac.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Spring, Acryl on Canvas, 100 x 80 cm (2023)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal4"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls4"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Blue_Ocean_V.98e29849.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Blue_Ocean_V2.fd3df1fb.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls4"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls4"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Blue Ocean, Acryl on Canvas, 100 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal5"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls5"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Green_White_V.becf8e92.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Green_White_V2.8381e264.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls5"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls5"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Green White, Acryl on Canvas, 100 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal6"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls6"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Calm_V.3f9cd300.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Calm_V2.1a6d8ee9.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls6"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls6"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Calm, Acryl on Canvas, 60 x 60 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal7"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls7"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Neon_V.636d366c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Neon_V2.5f170928.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls7"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls7"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon, Acryl on Canvas, 60 x 60 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal8"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls8"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_neon_2_Ansicht1.0d09d8d0.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_neon_2_Ansicht2.74db2184.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_neon_2_Ansicht3.d2cbcb7a.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls8"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls8"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon 2, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal9"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls9"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Neon_3_neu_Ansicht1.81e782c1.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Neon_3_neu_Ansicht2.69c838b2.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls9"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon 3, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal10"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls10"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Neon_4_Ansicht1.1e22d37c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Neon_4_Ansicht2.65b9223d.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls10"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon 4, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal11"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls11"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_neon_5_Ansicht1.6ff69e69.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_neon_5_Ansicht2.b9f757fe.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_neon_5_Ansicht3.118fe27e.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls11"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon 5, Acryl on Canvas, 80 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal12"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls12"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Calm_Ansicht1.d724fffc.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Calm_Ansicht2.0539032c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls12"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Calm 2, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal13"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls13"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Ocean_2_Ansicht1.c17449b8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Ocean_2_Ansicht2.bd89fb62.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Ocean_2_Ansicht3.7e40ad93.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls13"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Ocean 2, Acryl on Canvas, 120 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal14"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls14"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink_Neon_dream_Ansicht1.efcf023a.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink_Neon_dream_Ansicht2.7a2554a3.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls14"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Neon Dreamland, Acryl on Canvas, 80 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal15"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls15"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Calm_beige_Ansicht1.5f544f98.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Calm_beige_Ansicht2.29854702.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Calm_beige_Ansicht3.7786793a.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls15"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Calm Beige, Acryl on Canvas, 80 x 80 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal16"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls16"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Beige_wonderland_Ansicht1.c7882251.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Beige_wonderland_Ansicht2.b34bbd2f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls16"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls16"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Beige Wonderland, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal17"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls17"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Greige_1_Ansicht1.7a64e237.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greige_1_Ansicht2.32f9a40b.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greige_1_Ansicht3.1d3aa6a2.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls17"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls17"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Greige, Acryl on Canvas, 120 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal18"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls18"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Greige_dark_Ansicht1.3dd2efb4.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greige_dark_Ansicht2.24b0bdbe.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls18"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls18"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Greige Dark, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal19"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls19"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Greige_light_Ansicht1.b8171bf8.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greige_light_Ansicht2.b9a30e91.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Greige_light_Ansicht3.81983334.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls19"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls19"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Greige Light, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal20"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls20"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/Pink-girl.4818134e.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink-girl_Ansicht1.b3152a3d.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/Pink-girl_Ansicht2.d423f97c.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls20"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls20"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">Pink Girl, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal21"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls21"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/White_1.85832be7.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_1_1.f7093ca6.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_1_2.96bc90dd.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_1_3.c7bb85f1.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls21"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls21"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">White 1, Acryl on Canvas, 40 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal22"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls22"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/White_2.3fe41497.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_2_1.03f5d6c6.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_2_2.e1057c58.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_2_3.0bb19dcb.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls22"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls22"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">White 2, Acryl on Canvas, 40 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal23"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls23"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/White_Splash.47ef491d.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_1.35fe9003.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_2.37e17da7.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_3.e07f5b6f.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_4.d74e5fcb.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_5.8bd8cc50.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_6.f9732813.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
              <div class="carousel-item">
                <img
                  src="/img/White_Splash_7.1ccc3777.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls23"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls23"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">White Splash, Acryl on Canvas, 100 x 100 cm (2024)</div>
      </div>
    </div>
  </div>
  <div
    class="modal fade"
    id="exampleModal24"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body">
          <div
            id="carouselExampleControls24"
            class="carousel carousel-dark slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="/img/White_Greige.fffdcad3.jpg"
                  class="img-fluid"
                  style="max-height: 70vh"
                  alt="..."
                />
              </div>
            </div>
            <button
              class="carousel-control-prev"
              type="button"
              data-bs-target="#carouselExampleControls24"
              data-bs-slide="prev"
            >
              <span class="carousel-control-prev-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Previous</span></button
            ><button
              class="carousel-control-next"
              type="button"
              data-bs-target="#carouselExampleControls24"
              data-bs-slide="next"
            >
              <span class="carousel-control-next-icon" aria-hidden="true"></span
              ><span class="visually-hidden">Next</span>
            </button>
          </div>
        </div>
        <div class="modal-footer">White Greige, Acryl on Canvas, 120 x 120 cm (2024)</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Calm",
};
</script>
